import { render, staticRenderFns } from "./d2-demo-article.vue?vue&type=template&id=1b29c347&scoped=true&"
import script from "./d2-demo-article.vue?vue&type=script&lang=js&"
export * from "./d2-demo-article.vue?vue&type=script&lang=js&"
import style0 from "./d2-demo-article.vue?vue&type=style&index=0&id=1b29c347&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b29c347",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JG\\jg\\IWMS5.0\\SRM\\GIT\\SRM.VUE\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b29c347')) {
      api.createRecord('1b29c347', component.options)
    } else {
      api.reload('1b29c347', component.options)
    }
    module.hot.accept("./d2-demo-article.vue?vue&type=template&id=1b29c347&scoped=true&", function () {
      api.rerender('1b29c347', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/demo/components/container/components/d2-demo-article.vue"
export default component.exports